import './App.css';
import WebsiteContainer from './components/WebsiteContainer';

// App contains Website Container, which houses all pages
function App() {
  return (
    <>
      <WebsiteContainer />
    </>
  );
};

export default App;
